"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const focus_trap_react_1 = __importDefault(require("focus-trap-react"));
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const useIFrameOffset = () => {
    const [offsetTop, setOffset] = react_1.useState(null);
    react_1.useEffect(() => {
        if (!('parentIFrame' in window)) {
            setOffset(0);
            return;
        }
        window.parentIFrame.getPageInfo(({ scrollTop, offsetTop }) => {
            setOffset(scrollTop - offsetTop);
            window.parentIFrame.getPageInfo(false);
        });
    }, []);
    return offsetTop;
};
function Overlay(_a) {
    var _b;
    var { onClose, children, className } = _a, otherProps = __rest(_a, ["onClose", "children", "className"]);
    react_1.useEffect(() => {
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('no-scroll');
        return () => {
            body.classList.remove('no-scroll');
        };
    }, []);
    const offsetTop = useIFrameOffset();
    if (offsetTop === null) {
        return null;
    }
    return (jsx_runtime_1.jsx(StyledOverlayWrapper, Object.assign({ offsetTop: Math.max(0, offsetTop) }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: "overlayContent" }, { children: jsx_runtime_1.jsx(focus_trap_react_1.default, Object.assign({ focusTrapOptions: {
                    onDeactivate: onClose,
                    clickOutsideDeactivates: !!onClose,
                } }, { children: jsx_runtime_1.jsxs("div", Object.assign({ "aria-modal": "true", className: (_b = 'ui__ card  ' + className) !== null && _b !== void 0 ? _b : '' }, otherProps, { children: [children, onClose && (jsx_runtime_1.jsx("button", Object.assign({ "aria-label": "Fermer", onClick: onClose, className: "overlayCloseButton" }, { children: "\u00D7" }), void 0))] }), void 0) }), void 0) }), void 0) }), void 0));
}
exports.default = Overlay;
const StyledOverlayWrapper = styled_components_1.default.div `
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(255, 255, 255, 0.9);
	max-height: 100vh;
	overflow: auto;
	z-index: 2;
	.overlayContent {
		${({ offsetTop }) => offsetTop
    ? styled_components_1.css `
						transform: translateY(${offsetTop}px);
				  `
    : styled_components_1.css `
						bottom: 0;
						max-height: 80vh;
				  `}
		position: absolute;
	}
	.overlayCloseButton {
		position: fixed;
		background-color: white;
		border-top-left-radius: 100%;
		text-decoration: none;
		font-size: 2.5rem;
		border-top: 0.5rem solid white;
		border-left: 0.5rem solid white;
		bottom: 0;
		right: 0;
		color: var(--lighterTextColor);
		padding: 0 1rem;
		text-decoration: none;
	}
	.ui__.card[aria-modal='true'] {
		padding-bottom: 4rem;
		display: flex;
		flex-direction: column;
	}
	@media (max-width: 600px) {
		.overlayContent {
			width: 100%;
		}
		.overlayCloseButton {
			position: fixed;
			bottom: 0;
			right: 0;
			line-height: 1rem;
			padding: 1.2rem;
			padding-bottom: 1.5rem;
			font-size: 3rem;
			background: var(--lighterColor);
		}
	}

	@media (min-width: 600px) {
		.overlayCloseButton {
			position: absolute;
			top: 0;
			bottom: auto;
			right: 0;
			padding: 0 0.5rem;
			font-size: 2rem;
		}
		.overlayContent {
			transform: translateX(-50%)
				translateY(calc(${({ offsetTop }) => offsetTop}px + 5rem));
			left: 50%;
			width: 80%;
			bottom: auto;
			height: auto;
			max-width: 40em;
			min-height: 6em;
		}
		.ui__.card[aria-modal='true'] {
			padding-bottom: 2rem;
			margin-bottom: 2rem;
		}
	}
`;
